import * as React from "react";
import Svg, { Rect, G, Path, Defs, ClipPath } from "react-native-svg";
const HandsDown = (props: any) => (
  <Svg
    width={43}
    height={42}
    viewBox="0 0 43 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Rect x={0.5} width={42} height={42} rx={4.2} fill="#EBF2FF" />
    <Rect
      x={4.48242}
      y={4.34521}
      width={34.0345}
      height={34.0345}
      rx={2.89655}
      fill="white"
    />
    <G clipPath="url(#clip0_1713_15092)">
      <Path
        d="M13.4688 18.875H30.5312L22 13.625L13.4688 18.875Z"
        stroke="#2D57D9"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M16.0938 18.875V25.4375"
        stroke="#2D57D9"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M20.0312 18.875V25.4375"
        stroke="#2D57D9"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M23.9688 18.875V25.4375"
        stroke="#2D57D9"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M27.9062 18.875V25.4375"
        stroke="#2D57D9"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M14.125 25.4375H29.875"
        stroke="#2D57D9"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M12.8125 28.0625H31.1875"
        stroke="#2D57D9"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </G>
    <Defs>
      <ClipPath id="clip0_1713_15092">
        <Rect
          width={21}
          height={21}
          fill="white"
          transform="translate(11.5 11)"
        />
      </ClipPath>
    </Defs>
  </Svg>
);
export default HandsDown;
